

$(document).on('change', 'input[class=autosubmit][type=checkbox]', function(evt) {
  $(this).closest('form').submit()
  console.log('autosubmit');
});